import { render, staticRenderFns } from "./AamsUnitRegInfo.vue?vue&type=template&id=7c65ce7c&scoped=true&"
import script from "./AamsUnitRegInfo.vue?vue&type=script&lang=js&"
export * from "./AamsUnitRegInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c65ce7c",
  null
  
)

export default component.exports